import(/* webpackMode: "eager" */ "/app/src/app/(pages)/errors/404/page.tsx")